import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import complaintsImage from '../../assets/backgrounds/complaints.png';
import livroReclamacoesLogo from '../../assets/livro-de-reclamacoes.png';
import './styles.css';

const ComplaintsBook = () => {
  useEffect(() => {
    document.body.classList.add('complaints-page');
    return () => {
      document.body.classList.remove('complaints-page');
    };
  }, []);

  return (
    <section className="complaints-section">
      <div className="complaints-hero">
        <img src={complaintsImage} alt="Livro de Reclamações" />
        <div className="hero-content">
          <h1>Livro de Reclamações</h1>
          <p>Seu espaço para registrar sugestões e reclamações sobre nossos serviços</p>
        </div>
      </div>
      
      <div className="complaints-container">
        <div className="complaints-content">
          <div className="official-complaints-book">
            <div className="official-logo">
              <img src={livroReclamacoesLogo} alt="Livro de Reclamações Oficial" />
            </div>
            <div className="official-info">
              <h2>Livro de Reclamações Oficial</h2>
              <p>A JoviPlanet faz parte da iniciativa do Livro de Reclamações Eletrônico, uma plataforma oficial para exercício do seu direito à queixa em Portugal e na União Europeia.</p>
              <div className="highlight-box">
                <p>Caso não consiga resolver sua questão através dos nossos canais de atendimento, você tem o direito de registrar uma reclamação oficial através do portal do Livro de Reclamações.</p>
                <a href="https://www.livroreclamacoes.pt/Pedido/Reclamacao" target="_blank" rel="noopener noreferrer" className="official-button">
                  Acessar Portal Oficial do Livro de Reclamações
                </a>
              </div>
            </div>
          </div>

          <div className="complaints-index">
            <h2>Índice</h2>
            <ul className="index-list">
              <li><a href="#introducao"><span>1.</span> Introdução</a></li>
              <li><a href="#direitos"><span>2.</span> Os seus Direitos</a></li>
              <li><a href="#como-registrar"><span>3.</span> Como Registrar</a></li>
              <li><a href="#prazos"><span>4.</span> Prazos de Resposta</a></li>
              <li><a href="#procedimentos"><span>5.</span> Procedimentos</a></li>
              <li><a href="#canais"><span>6.</span> Canais de Atendimento</a></li>
              <li><a href="#garantias"><span>7.</span>As nossas Garantias</a></li>
              <li><a href="#contato"><span>8.</span> Contato</a></li>
            </ul>
          </div>

          <section id="introducao" className="policy-section">
            <h2>1. Introdução</h2>
            <p>O Livro de Reclamações da JoviPlanet é um canal oficial para registro de reclamações, sugestões e elogios dos nossos serviços. Valorizamos a sua opinião e comprometemos-nos a analisar cada manifestação com atenção e respeito.</p>
            <div className="highlight-box">
              <p>Todas as reclamações são tratadas com sigilo e imparcialidade, visando a melhoria contínua dos nossos serviços.</p>
            </div>
          </section>

          <section id="direitos" className="policy-section">
            <h2>2. Os Seus Direitos</h2>
            <p>Como usuário da JoviPlanet, você tem direito a:</p>
            <ul>
              <li>Registrar reclamações, sugestões e elogios</li>
              <li>Receber um protocolo de atendimento</li>
              <li>Acompanhar o status da sua manifestação</li>
              <li>Obter resposta no prazo estabelecido</li>
            </ul>
            <div className="highlight-box">
              <p>Garantimos total transparência no tratamento das suas manifestações.</p>
            </div>
          </section>

          <section id="como-registrar" className="policy-section">
            <h2>3. Como Registrar</h2>
            <h3>3.1 Registro Online</h3>
            <p>Para registrar uma manifestação online:</p>
            <ul>
              <li>Acesse à sua conta na plataforma</li>
              <li>Navegue até à secção "Livro de Reclamações"</li>
              <li>Preencha o formulário com os detalhes</li>
              <li>Anexe documentos relevantes (se necessário)</li>
            </ul>

            <h3>3.2 Outros Canais</h3>
            <p>Também aceitamos registros através de:</p>
            <ul>
              <li>Email dedicado</li>
              <li></li>
              <li>Chat online</li>
              <li></li>
            </ul>
          </section>

          <section id="prazos" className="policy-section">
            <h2>4. Prazos de Resposta</h2>
            <p>Nos comprometemos com os seguintes prazos:</p>
            <ul>
              <li>Confirmação de recebimento: até 24 horas</li>
              <li>Primeira análise: até 3 dias úteis</li>
              <li>Resposta final: até 10 dias úteis</li>
              <li>Casos complexos: até 20 dias úteis</li>
            </ul>
            <div className="highlight-box">
              <p>Em casos excepcionais, você será notificado sobre a necessidade do prazo adicional.</p>
            </div>
          </section>

          <section id="procedimentos" className="policy-section">
            <h2>5. Procedimentos</h2>
            <h3>5.1 Análise</h3>
            <p>Cada manifestação passa por:</p>
            <ul>
              <li>Registro e categorização</li>
              <li>Análise preliminar</li>
              <li>Investigação detalhada</li>
              <li>Elaboração de resposta</li>
            </ul>

            <h3>5.2 Tratamento</h3>
            <p>A nossa equipa especializada:</p>
            <ul>
              <li>Avalia cada caso individualmente</li>
              <li>Busca soluções adequadas</li>
              <li>Implementa medidas corretivas</li>
              <li>Monitora a satisfação do usuário</li>
            </ul>
          </section>

          <section id="canais" className="policy-section">
            <h2>6. Canais de Atendimento</h2>
            <p>Disponibilizamos diversos canais para o seu contato:</p>
            <ul>
              <li>Portal do Cliente (24/7)</li>
              <li></li>
              <li>Email dedicado para reclamações</li>
              <li>Chat online em horário comercial</li>
            </ul>
          </section>

          <section id="garantias" className="policy-section">
            <h2>7. As nossas Garantias</h2>
            <p>Comprometemo-nos a:</p>
            <ul>
              <li>Tratar todas as manifestações com seriedade</li>
              <li>Manter sigilo das informações</li>
              <li>Buscar soluções efetivas</li>
              <li>Melhorar continuamente os nossos serviços</li>
            </ul>
            <div className="highlight-box">
              <p>A sua satisfação é a nossa prioridade, e cada feedback ajuda-nos a evoluir.</p>
            </div>
          </section>

          <section id="contato" className="policy-section">
            <h2>8. Contato</h2>
            <p>Para entrar em contato com a nossa equipa de atendimento:</p>
            <div className="highlight-box">
              <Link to="/contact" className="contact-button">
                Acessar formulário de contato
              </Link>
            </div>
            <div className="official-note">
              <p>Caso não fique satisfeito com o atendimento recebido através dos nossos canais, você pode registrar as suas reclamação no portal oficial do Livro de Reclamações:</p>
              <a href="https://www.livroreclamacoes.pt/Pedido/Reclamacao" target="_blank" rel="noopener noreferrer" className="official-link">
                www.livroreclamacoes.pt
              </a>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default ComplaintsBook; 